import key from 'weak-key';

// styles
import styles from './showroom.module.scss';

// components
import { Image } from 'components/image/image';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';
import { isEmpty } from 'utils/is-empty';
import { svgMarker } from './svg-marker';

type MapLegendProps = {
  categories?: {
    categoryName: string;
    color: string;
  }[];
  isNord?: boolean;
};

export function MapLegend({ categories = [], isNord = false }: Readonly<MapLegendProps>) {
  if (isEmpty(categories)) {
    return null;
  }

  function getIcon(color) {
    if (isNord) {
      return `data:image/svg+xml;base64,${svgMarker(color || '#26513B')}`;
    }

    return `/images/marker/marker-${color}.svg`;
  }

  return (
    <div className={classNameBuilder(styles.legendWrapper, isNord && styles.nord)}>
      {categories
        .filter(({ categoryName }) => !isEmpty((categoryName || '').trim()))
        .map(
          (category) =>
            !isEmpty(category) && (
              <div className={styles.legendItem} key={key(category)}>
                <Image
                  key={key(category)}
                  src={getIcon(category.color)}
                  alt={category.categoryName}
                  title={category.categoryName}
                  staticImage
                />
                {category.categoryName}
              </div>
            ),
        )}
    </div>
  );
}
